import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Region } from '../shared/region.model';
import { LoaderService, NotificationService } from 'src/app/shared/session';
import { RegionService } from '../shared/region.service';

@Component({
  selector: 'app-region-view',
  templateUrl: './region-view.component.html',
})
export class RegionViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;

  region: Region;
  msgErrorGet: string;

  constructor(
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private regionService: RegionService,
  ) { }

  ngOnInit() {
    this.initData();
  }

  async initData() {
    this.region = new Region();
    this.msgErrorGet = 'Error al obtener región';
    this.loaderService.show();
    try {
      this.region = await this.regionService.obtenerRegion(this.data.region.id).toPromise();
    } catch (error) {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    } finally {
      this.loaderService.hide();
    }
  }
}
